
import React from 'react'
import { ToastContainer } from 'react-toastify';
import './toast.css'
function Toast({notify}) {

    return (
        <div className='toast_container'>
            <div>
                <ToastContainer className={'toast_container'} />
            </div>
        </div>
    );

}

export default Toast;